import { type JSX, useEffect, useState } from 'react';
import ShimmerComponents from '@alltrails/core/components/ShimmerComponents';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import Link from '@alltrails/denali/components/Link';
import { LinkInfo } from '@alltrails/denali/types';
import useCardPhotos from '../../hooks/useCardPhotos';
import styles from './TrailAvatar.module.scss';

const { TrailPhotoShimmer } = ShimmerComponents;

export type Props = {
  linkInfo: LinkInfo;
  trailId: number;
  trailName: string;
};

const TrailAvatar = ({ linkInfo, trailId, trailName }: Props): JSX.Element => {
  const [src, setSrc] = useState('');
  const { photos } = useCardPhotos('trails', trailId, '80x80', 1);

  useEffect(() => {
    setSrc(photos?.[0]);
  }, [photos]);

  return (
    <Link {...linkInfo}>
      {src === '' ? (
        <ShimmerContainer>
          <TrailPhotoShimmer />
        </ShimmerContainer>
      ) : (
        <img className={styles.avatarPhoto} onError={() => setSrc('')} src={src} alt={trailName} loading="lazy" />
      )}
    </Link>
  );
};

export default TrailAvatar;
